import { injectable } from 'inversify';

import { BlotterServiceAbstract } from './blotter.service';
import { EBlotterTab } from '../../enums';
import { getBlotterSpotColumnDefs } from '.';
import { IOrderReport, ORDER_TERMINAL_STATUSES, Predicate } from '../../interfaces';

@injectable()
export class BlotterSpotService extends BlotterServiceAbstract {
    filter: Predicate<IOrderReport> = (order: IOrderReport) =>
        order.orderType === 'spot' &&
        ORDER_TERMINAL_STATUSES.includes(order.state as typeof ORDER_TERMINAL_STATUSES[number]);
    columnDefinitions = getBlotterSpotColumnDefs;
    type = 'spot' as EBlotterTab;
    isRowActionsEnabled = false;
}
